// extracted by mini-css-extract-plugin
module.exports = {"mapWrapper":"country-data-map_mapWrapper__34_BY","positionToScroll":"country-data-map_positionToScroll__7Q3yJ","footerNote":"country-data-map_footerNote__yNVs3"};